// src/pages/AboutPage.js
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function AboutPage() {
  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>Nada Upashama</Typography>
      <Typography paragraph>
        Nada Upashama comprised of three treatment modules:
      </Typography>
      <Typography component="div" paragraph>
        <ul>
          <li><b>Pitch and Loudness:</b> A client has to identify his pitch by changing the frequency. At matched pitch the level is varied to identify the loudness.</li>
          <li><b>Most comfortable level:</b> A client has to identify his MCL level by changing the level while listening to story.</li>
          <li><b>Frequency discrimination task:</b> A client has to identify the target tone in the presence of distractors after identifying their pitch and most comfortable level in the ear having tinnitus.</li>
 
        </ul>
      </Typography>

      <Typography variant="h6" gutterBottom>Principal Investigator</Typography>
      <Typography paragraph>Dr. Hemanth N, Professor of Audiology, JSSISH, Mysuru</Typography>

      <Typography variant="h6" gutterBottom>Co-Investigators</Typography>
      <Typography paragraph>
        Dr. Hemanth Bhargav, Assistant Professor of Yoga, NIMHANS, Bengaluru<br />
        Prof. Ramakrishna B R, Vice Chancellor, SVYSA University, Bengaluru<br />
        Dr. Kishore, Associate Professor, JSS AHER, Mysuru
      </Typography>

      <Typography variant="h6" gutterBottom>Project Officers</Typography>
      <Typography paragraph>
        Ms. Sushma Chandrashekar
      </Typography>

      <Typography variant="body2" color="textSecondary">
        <b>Funding Source:</b> Department of Science and Technology (DST)<br />
        <b>Citation:</b> Hemanth N., Hemanth B., Ramakrishna, B. R., Kishore. (2023). Efficacy of Tele-Yoga Program as an Adjuvant to Conventional Management in Patients Suffering from Tinnitus: A Randomized Controlled Trial. Submitting to DST.
      </Typography>
    </Box>
  );
}
